import * as select from "./select"
import * as button from "./button"
import * as d3 from "d3"

export const copy = (): boolean => {
  const selection = select.getSelection()
  if (selection?.size()) {
    let outerHTML = ""
    selection?.each(function () {
      const selectedButton = d3.select(this)
      outerHTML += selectedButton.node()?.outerHTML
    })
    if (outerHTML.length) {
      if (navigator.clipboard) {
        void navigator.clipboard.writeText(outerHTML)
        return true
      }
    }
  }
  return false
}

export const paste = async (event?: ClipboardEvent) => {
  const clipboardContent = event
    ? event?.clipboardData?.getData("text/plain")
    : await navigator.clipboard.readText()
  if (clipboardContent && clipboardContent.indexOf("playerdash-dashboard-button") !== -1) {
    const newButtons = button.createFromOuterHTML(d3.select("#svg-dashboard"), clipboardContent)
    select.button(newButtons)

    // update the clipboard data, such that a consecutive paste event
    // will move the buttons relativ to the above added buttons
    // Chrome: supports the permission check and grants write permission
    // Firefox: does not support the permission check, but grants write permission
    // Safari: supports the permission check, but does not grant write permission
    let permissionStatus
    try {
      permissionStatus = !!navigator.permissions
        ? (
            await navigator.permissions.query({
              name: "clipboard-write" as PermissionName,
            })
          ).state
        : "forbidden"
    } catch (error) {}
    if (permissionStatus !== "forbidden") {
      return copy()
    }
  }
  return false
}

export const cut = (): boolean => {
  copy()
  select.getSelection()?.remove()
  return false
}

export const duplicate = (): boolean => {
  const newButton = button.clone(select.getSelection())
  select.button(newButton)
  return true
}

export const remove = (): boolean => {
  const haveSelection = !!select.getSelection()?.size
  select.getSelection()?.remove()
  return haveSelection
}

export const haveContentToPaste = async () => {
  const clipboardContent = await navigator.clipboard.readText()
  return clipboardContent && clipboardContent.indexOf("playerdash-dashboard-button") !== -1
}
